export default "__VITE_ASSET__iQNfp9iz__"